import _find from 'lodash/find';
import {OutputType} from 'common/src/modules/nodes/nodes.types';
import {sharedCampaigns} from '@cl/shared';

export function isInsightOfCurrentVersionFallbackCreative({
  fallbackCreativeNodeId,
  targetNodeId,
  sourceNodeId,
}: {
  targetNodeId: number;
  fallbackCreativeNodeId: number;
  sourceNodeId: number;
}) {
  if (!sharedCampaigns.nodesRef.value[sourceNodeId]) return false;
  const targetNodeOfFallbackOutput = _find(sharedCampaigns.nodesRef.value[sourceNodeId].outputs, {
    type: OutputType.Fallback,
  })?.nodeId;

  return targetNodeId === fallbackCreativeNodeId && !targetNodeOfFallbackOutput;
}
